import Vue from 'vue'
import Vuex from 'vuex'

import { module as treeViewModule } from './modules/treeViewModule.js'
import { module as documentGridModule } from './modules/documentGridModule.js'
import { module as docstreamSettingModule } from './modules/docstreamSettingsModule.js'
import { module as userInformationModule } from './modules/userInformationModule.js'

Vue.use(Vuex)

const modules = {
  treeViewModule: treeViewModule,
  documentGridModule: documentGridModule,
  docstreamSettingModule,
  userInformationModule
}

const actions = {
  emailIsValid (context, email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }
}

const store = new Vuex.Store({
  plugins: [],
  actions,
  modules
})

export default store



// WEBPACK FOOTER //
// ./src/Store/store.js